import React, { useEffect } from "react";
import { useCommonApi } from "../store/api/hooks/commonApiHook";

interface LookupValuesProps {
    id: number[] | string[] | []; // Array of LookupTypeIds to fetch
}

const LookupValues = ({ id }: LookupValuesProps) => {
    const commonApi = useCommonApi();

    const fetchLookupValues = () => {
        commonApi.lookupValues(
            {
                LookupTypeIds: id,
            },
            (response: any) => {},
            (error: any) => {}
        );
    };

    useEffect(() => {
        // Call the lookup values API on component mount
        fetchLookupValues();
    }, []);

    return null; // This component doesn't render anything
};

export default LookupValues;
